/**
 * Codex — short atmospheric bios for each biome. Surfaces in the
 * settings drawer alongside the achievement panel.
 *
 * Treat the dossier rule "everything visible is procedural" as guidance
 * here too: no claim of authored places, no proper nouns beyond the
 * biome names already defined in game/biomes.ts.
 */

export interface CodexEntry {
  id: string;
  title: string;
  body: string;
}

export const CODEX: CodexEntry[] = [
  {
    id: "helios",
    title: "Helios",
    body: "A wash of cold dust under a violet star. The first rings glow cyan against a near-black sky; the dust thickens only when you push past the early gates.",
  },
  {
    id: "vermilion",
    title: "Vermilion",
    body: "Iron-rich nebula, lit from inside. Rings turn amber, the fog warms, and the lattice feels close. Easy to lose your line in the haze when boost saturates the cabin.",
  },
  {
    id: "cyan_reach",
    title: "Cyan Reach",
    body: "A long thin band of ionised hydrogen. Cooler than Helios, brighter than Vermilion. Streaks read clearest here — the trail you leave is the trail you fly.",
  },
  {
    id: "magnetar",
    title: "Magnetar",
    body: "Magnetic-field interference paints the dust magenta and the rings ride on a tighter drift. The audio bed thins; what's left is mostly your own approach rumble.",
  },
  {
    id: "lattice",
    title: "The Lattice",
    body: "Not a place — the pattern the rings make when you read them as a continuous structure. Pilots who hold long streaks claim it 'opens'. Climax fold at streak thirty is the closest we have to evidence.",
  },
];

export function codexHtml(): string {
  return CODEX.map(
    (e) =>
      `<li><strong>${escapeHtml(e.title)}</strong><span class="codex-body">${escapeHtml(e.body)}</span></li>`,
  ).join("");
}

function escapeHtml(s: string) {
  return s.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!,
  );
}
